'use client';

// Static, heavily-dimmed pond still for utility pages (/book) where the live
// WebGL scene is a legibility + perf/battery liability. No canvas, no animation.
export function StaticPondBackground() {
  return (
    <div aria-hidden style={{ position: 'fixed', inset: 0, zIndex: 0, pointerEvents: 'none' }}>
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: 'url(/pond-still.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      {/* Heavy scrim — pull the still down toward the body tone so panels and
          form text dominate. Slightly stronger at the bottom where the form sits. */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          // rgba equivalent of var(--bg-primary) (#0b0a08) at 78%→90% — avoids
          // color-mix() so the scrim can never silently drop on older engines.
          background:
            'linear-gradient(to bottom, rgba(11,10,8,0.78), rgba(11,10,8,0.90))',
        }}
      />
    </div>
  );
}
